import React, {useRef, useState, useEffect} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import RoomTypeLangs from "./_langs";
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";

// labels
import {PH_CODE, PH_ORDER} from "../../../components/i18n/placeHolders"
import {
    LB_CODE, INTERNATIONAL, LB_ORDER,
    LB_STATUS, REQUIRED, LB_CATEGORY
} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {roomTypeService} from "../../../jwt/_services/hotel/roomTypeService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import TranslateButton from "../../../components/buttons/TranslateButton";

import ImagePicker from "../../../components/imagePickerComponents/ImagePicker";
import {roomTypeMediaService} from "../../../jwt/_services/core/roomTypeMediaService";


const RoomTypeForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, app, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}
    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [category, setCategory] = useState(domainObject?.category || null);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);






    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                code: domainObject?.code,
                showOrder: domainObject?.showOrder,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);





    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                category: !category ? null : { id: category },
                langs,
            }
        };

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if (!editMode)
            genericIndexedActions.save(path, roomTypeService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, roomTypeService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    const refreshObject = () => genericIndexedActions.get(path, roomTypeService, domainObject?.id, fbDataBase.id);


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={roomTypeService} />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="6">
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>{LB_CODE}</Label>
                                    <Input
                                        type="text"
                                        name="code"
                                        placeholder={PH_CODE}
                                        innerRef={register}
                                    />
                                    {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <SelectGeneric
                                title={LB_CATEGORY}
                                        initialValue={ category }
                                        setExternalValue={ setCategory }
                                        provider = { hotelCategoryProvider }
                                        getAllCategories={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>{LB_ORDER}</Label>
                                    <Input
                                        type="number"
                                        name="showOrder"
                                        placeholder={PH_ORDER}
                                        innerRef={register}
                                    />
                                    { errors.showOrder && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.showOrder?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>{LB_STATUS}</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={ () => setStatus(!status) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col md="6">
                        <ImagePicker
                            className={'roomType'}
                            title={'Media'}
                            app={app}
                            service={roomTypeService}
                            baseMediaService={roomTypeMediaService}
                            objectMedia={domainObject}
                            afterUpload={refreshObject}
                        />
                    </Col>
                </Row>
                <Row>
                </Row>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <RoomTypeLangs
                        langs={langs}
                        setLangs={setLangs}
                        translatableLangs={translatableLangs}
                    />
                </CardBody>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default RoomTypeForm